import Icon from '../components/Icon.vue'

Icon.register({
  'bezier-curve': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M368 32H272C254.3 32 240 46.3 240 64V160C240 177.7 254.3 192 272 192H368C385.7 192 400 177.7 400 160V64C400 46.3 385.7 32 368 32zM208 88H123.3C113.8 64.6 90.8 48 64 48 28.7 48 0 76.6 0 112S28.7 176 64 176C90.8 176 113.8 159.4 123.3 136H203C147.6 168.5 107.1 223.3 93.4 288H142.8C154.1 246.4 179.6 210.8 213.9 186.4 210.2 178.4 208 169.4 208 160V88zM160 320H64C46.3 320 32 334.3 32 352V448C32 465.7 46.3 480 64 480H160C177.7 480 192 465.7 192 448V352C192 334.3 177.7 320 160 320zM576 48C549.2 48 526.3 64.6 516.8 88H432V160C432 169.4 429.8 178.4 426.1 186.4 460.4 210.8 485.9 246.4 497.2 288H546.6C532.9 223.3 492.4 168.5 437 136H516.8C526.3 159.4 549.2 176 576 176 611.3 176 640 147.4 640 112S611.3 48 576 48zM576 320H480C462.3 320 448 334.3 448 352V448C448 465.7 462.3 480 480 480H576C593.7 480 608 465.7 608 448V352C608 334.3 593.7 320 576 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bezier-curve.js
// module id = u8yE
// module chunks = 144